import { FC, ReactNode } from "react";

import { Shelf, Stack } from "capitalrx-components-2.0/lib/layout";

import styles from "./styles.module.scss";
import { NoPaddingFormComponents } from "../Unpadded";

interface GroupLayoutWrapperProps extends NoPaddingFormComponents {
  readonly children: ReactNode,
  readonly orientation: "vertical" | "horizontal";
}

export const GroupLayoutWrapper: FC<GroupLayoutWrapperProps> = ({ children, orientation, unpadded }) => {

  if (orientation === "horizontal") {
    return (
      <Shelf className={[styles.GroupLayoutWrapper, { unpadded }]}>
        {children}
      </Shelf>
    );
  }

  return (
    <Stack spacing={unpadded ? "small" : "none"}>
      {children}
    </Stack>
  );
};
